export default {
    title: 'Inställningar',
    profile: 'Min profil',
    name: 'Namn',
    company: 'Skola',
    email: 'E-post',
    language: 'Språk',
    logout: 'Logga ut',

};
